import React from 'react';
import { Link } from 'react-router-dom';
import { isExternalHttpUrl } from '../config/partnerPanel';

type Props = {
  to: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
};

/** Uses a plain anchor for absolute http(s) URLs (external partner panel); otherwise react-router Link. */
export const PartnerPanelLink: React.FC<Props> = ({ to, className, children, onClick }) => {
  if (isExternalHttpUrl(to)) {
    return (
      <a href={to} className={className} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={className} onClick={onClick}>
      {children}
    </Link>
  );
};
